import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import "jquery/Extend/global";
import { Promise } from "es6-promise-polyfill";

let breakpoints = function() {
  return [
    {
      name: "mobile",
      media: "screen and (min-width: 0px)",
      selector: "-mobile"
    },
    {
      name: "mobile-landscape",
      media: "screen and (min-width: 480px)",
      selector: "-mobile-landscape"
    },
    {
      name: "tablet-portrait",
      media: "screen and (min-width: 768px)",
      selector: "-tablet-portrait"
    },
    {
      name: "tablet-landscape",
      media: "screen and (min-width: 1024px)",
      selector: "-tablet-landscape",
      ie: true
    },
    {
      name: "desktop",
      media: "screen and (min-width: 1280px)",
      selector: "-desktop"
    }
  ];
};

class _MediaQueryPublisher extends Class {
  constructor(breakpoints) {
    super();
    var self = this;
    this.breakpoints = breakpoints;
    this.setUpEvents();
    //publish media query once entire stack has finished
    //e.g. once all modules have subscribed
    self.onMediaQuery();
  }

  setUpEvents() {
    var self = this;
    $.each(this.breakpoints, function(i, breakpoint) {
      var mq = window.matchMedia(breakpoint.media);
      breakpoint.query = mq;
      mq.addListener(function(mq) {
        self.updateQuery(mq);
        self.onMediaQuery();
      });
    });
  }

  updateQuery(mq) {
    $.each(this.breakpoints, function(i, breakpoint) {
      if (breakpoint.media === mq.media) {
        breakpoint.query = mq;
        return;
      }
    });
  }

  onMediaQuery() {
    var self = this;
    return new Promise(function(resolve, reject) {
      var breakpoint = self.currentBreakpoint();
      resolve(breakpoint);
      $(self).trigger("abacus:newBreakpoint", breakpoint);
    });
  }

  initialBreakpoint() {
    return this.onMediaQuery();
  }

  currentBreakpoint() {
    var currentBreakpoint,
      IE = $.isIE() && $.ieVersion() <= 8;

    $.each(this.breakpoints, function(key, bp) {
      if (IE) {
        if (bp.ie) {
          currentBreakpoint = bp.name;
        }
      } else if (bp.query.matches) {
        currentBreakpoint = bp.name;
      }
    });

    return currentBreakpoint;
  }
}

let MediaQueryPublisher = (Abacus.MediaQueryPublisher = new _MediaQueryPublisher(
  breakpoints()
));

export { MediaQueryPublisher };



// WEBPACK FOOTER //
// ./Javascript/core/classes/media.query.publisher.class.js